export const ERROR_LOG_CREATE_START = 'ERROR_LOG_CREATE_START';
export const ERROR_LOG_CREATE_SUCCESS = 'ERROR_LOG_CREATE_SUCCESS';
export const ERROR_LOG_CREATE_FAIL = 'ERROR_LOG_CREATE_FAIL';
